import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';

import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoginService } from 'src/app/login/login.service';
import { environment } from 'src/environments/environment';

import { DownloadService } from '../../services/download.service';

@Component({
  selector: 'app-infodownload',
  templateUrl: './infodownload.component.html',
  styleUrls: ['./infodownload.component.scss'],
  providers: [MessageService]
})
export class InfodownloadComponent implements OnInit {
    infoDownloads$: Observable<any>;
    sections$: BehaviorSubject<any> = new BehaviorSubject(null);
    downloadPath: string = "";
    Files: any[] = [];
    selectedSection: string = null;
    newSectionName: string = '';

    constructor(private downloadService: DownloadService, public loginService: LoginService, private httpService: HttpClient, private messageService: MessageService) { }

    public doDownload(str) {
        window.location.href = "/Download/GetInfoFile?filename=" + encodeURI(str);
    }

    ngOnInit(): void {
        this.downloadPath = environment.assetsInfo;
        this.loadData();
    }

    private loadData() {
        this.infoDownloads$ =
            this.downloadService.getAllInfo().pipe(
                map((data) => {
                    let arr: any = [];
                    for (let x of data) {
                        if (arr.some(e => e.section == x.Section)) {
                            arr.find(e => e.section == x.Section).downloads.push(x);
                        } else {
                            let dl = [];
                            dl.push(x);
                            arr.push({ downloads: dl, section: x.Section });
                        }
                    }
                    return arr;
                })
            );

        this.infoDownloads$.subscribe(data => {
            let sects = data.map(x => x.section);
            sects = sects.filter((x, i, a) => a.indexOf(x) == i).map(x => { return { name: x, value: x }; });
            sects.push({ name: '+ New Section...', value: '__new__' });
            this.sections$.next(sects);
        });
    }

    uploadFiles(uploader: any) {
        const effectiveSection = this.selectedSection === '__new__' ? this.newSectionName.trim() : this.selectedSection;

        if (!effectiveSection) {
            this.messageService.add({ key: 'Submitted', severity: 'warn', summary: 'Warning', detail: 'Please select or enter a section name.' });
            return;
        }

        this.Files = uploader.files;
        if (this.Files.length === 0) {
            this.messageService.add({ key: 'Submitted', severity: 'warn', summary: 'Warning', detail: 'Please select at least one file.' });
            return;
        }

        const frmData = new FormData();
        frmData.append("Form", "upload_form");
        frmData.append("Section", effectiveSection);

        for (var i = 0; i < this.Files.length; i++) {
            frmData.append("Files", this.Files[i]);
        }

        this.httpService.post(environment.localUrl + 'Upload/UploadInfo', frmData, { withCredentials: true }).subscribe(
            data => {
                this.messageService.add({ key: 'Submitted', severity: 'info', summary: 'Uploaded', detail: 'Upload finished.' });
                uploader.clear();
                this.selectedSection = null;
                this.newSectionName = '';
                this.loadData();
            },
            (err: HttpErrorResponse) => {
                console.log(err.message);
            }
        );
    }

    deleteFile(filename: string) {
        const frmData = new FormData();
        frmData.append("Form", "upload_form_delete");
        frmData.append("Filename", filename);

        this.httpService.post(environment.localUrl + 'Upload/DeleteInfo', frmData, { withCredentials: true }).subscribe(
            data => {
                this.messageService.add({ key: 'Submitted', severity: 'info', summary: 'Deleted', detail: 'File deleted successfully.' });
                this.loadData();
            },
            (err: HttpErrorResponse) => {
                console.log(err.message);
            }
        );
    }
}

